{
  "title": "Berkongsi lokasi anda membolehkan anda mempercepatkan proses daftar masuk",
  "body": "Maaf, tetapi kami tidak dapat melengkapkan daftar masuk anda tanpa akses kepada lokasi anda. Sila berikan akses lokasi untuk meneruskan. Kami hanya menggunakan lokasi anda untuk tujuan daftar masuk gudang dan tidak menyimpan atau berkongsi maklumat lokasi anda dengan pihak ketiga.",
  "shareLocation": "Kongsi lokasi saya"
}
